/*
 * @Descripttion: 首页banner
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-07-19 17:02:51
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2024-10-25 15:01:12
 */

const frontPage = {
  banner: {
    banner1: {
      title: ['让医疗更精准'],
      des: ['Bringing precision to medicine']
    },
    banner2: {
      title: ['开创FFR检测的<span class="fontW">无导丝时代</span>'],
      des: ['Pioneering the era of FFR testing without guide pressure wires']
    },
    banner3: {
      title: ['<span class="fontW">心脑血管病</span>研究领域专家'],
      des: ['Experts in the field of cardiovascular and cerebrovascular diseases']
    }
  },
  introduction: {
    title: '脉流科技',
    des: '让医疗更精准',
    banner: [
      {
        id: 1,
        title: '公司简介',
        des: ['脉流科技是一家基于医学大数据，应用计算仿真技术和人工智能算法提供心脑血管病精准化与个性化诊疗的创新公司，在计算仿真、人工智能和医学影像等方面技术积累尤为深厚。核心团队不仅懂技术，并且对临床有深入理解。']
      }, {
        id: 2,
        title: '团队',
        des: ['脉流科技汇集了在计算仿真、人工智能及医学影像等方面全球跨界融合的一流团队。', '创始团队拥有逾二十年世界级心脑血管领域科研经验，是心脑血管疾病血流动力学研究领域的专家，在学术行业中发表了数百篇论文，申请了超百项专利。', '核心研发团队由来自麻省理工、帝国理工等世界一流名校成员组成，在计算仿真、人工智能和医学影像等方面技术积累深厚。']
      }, {
        id: 3,
        title: '专业',
        des: ['脉流科技拥有丰富的国内外医疗界资源，并与世界一流的介入中心——美国布法罗GVI中心进行深度合作。拥有数十年与国内外临床医生深度合作的积累，目前与国内外上百家心脑血管医院建立深度的临床合作。全司70%人员深耕医疗临床和科研领域，并积累了丰富的大型医疗企业产品研发和市场经验。']
      }, {
        id: 4,
        title: '数据',
        des: ['凭借在深度学习算法、血流动力学分析算法、医学影像等领域的深厚积累，脉流科技与上百家医院的深度合作，积累了大量临床数据和影像数据，确保深度学习模型的训练和验证。']
      }
    ],
    related: {
      hospitals: '合作医院',
      province: '覆盖省份',
      second: '血流动力学分析',
      percentage: 'AccuFFRangio准确性'
    },
    more: '了解更多'
  },
  hexinchanping: {
    title: '核心产品',
    des: ['脉流科技已推出三大冠脉功能学评估系统，并提供完整的心脑血管病解决方案'],
    innovative: {
      skull: {
        title: '脑血管智能诊疗解决方案',
        img: require('@/assets/images/index/hxcp/skull.png'),
        more: 'intracranial',
        list: [
          {
            title: 'AneuFlow',
            des: '基于DSA、CTA、MRA影像，判断动脉瘤破裂风险，精准筛查与诊断，提前治疗',
            path: '/innovative/intracranial/aneuflow'
          }, {
            title: 'AneuGuide',
            des: '精准颅内动脉瘤介入手术必备工具，实时精准密网支架支架选型参考',
            path: '/innovative/intracranial/aneuguide'
          }, {
            title: 'AccuCTP',
            des: '基于颅内CT灌注影像定量极速精准分析脑梗梗死程度，争取黄金治疗时间',
            path: '/innovative/intracranial/accuctp'
          }, {
            title: 'AccuFFicas',
            des: '基于DSA、CTA影像，判断动脉狭窄程度，精准快速治疗中国人高发的动脉粥样硬化，避免大多数脑卒中发生',
            path: '/innovative/intracranial/accufficas'
          }
        ]
      },
      heart: {
        title: '心血管智能诊疗解决方案',
        img: require('@/assets/images/index/hxcp/heart.png'),
        more: 'intracardiac',
        list: [
          {
            title: 'AccuFFRct',
            des: '基于冠脉CTA影像，无创方式进行功能学评估，极速精准定量分析心肌缺血程度，精准诊断，成为精准介入治疗的前提',
            path: '/innovative/intracardiac/accuffrct'
          }, {
            title: 'AccuFFRangio',
            des: '基于冠脉造影，以无导丝方式，从功能学角度，极速精准定量分析心肌缺血程度',
            path: '/innovative/intracardiac/accuffrangio'
          }, {
            title: 'AccuIMR',
            des: '多角度展现DSA造影都无法显示的冠脉微循环状态，从微观层面精准诊断心肌缺血程度，弥补FFR仅覆盖宏观诊断的局限，备受业界推崇',
            path: '/innovative/intracardiac/accuimr'
          }
        ]
      },
      more: '查看更多>>',
      img_circle: require('@/assets/images/index/hxcp/circle.png'),
      circle_list: [
        {
          title: '筛查',
          img: require('@/assets/images/index/hxcp/icon1.png')
        }, {
          title: '治疗',
          img: require('@/assets/images/index/hxcp/icon2.png')
        }, {
          title: '诊断',
          img: require('@/assets/images/index/hxcp/icon3.png')
        }
      ],
      t_list: [
        require('@/assets/images/pc/index/hxcp/t_1.png'),
        require('@/assets/images/pc/index/hxcp/t_2.png'),
        require('@/assets/images/pc/index/hxcp/t_3.png'),
        require('@/assets/images/pc/index/hxcp/t_4.png')
      ],
      b_list: [
        require('@/assets/images/pc/index/hxcp/b_1.png'),
        require('@/assets/images/pc/index/hxcp/b_2.png'),
        require('@/assets/images/pc/index/hxcp/b_3.png'),
        require('@/assets/images/pc/index/hxcp/b_4.png')
      ],
      m_b_img: require('@/assets/images/m/index/hxcp/bottom.png')
    }
  },
  news: {
    title: '新闻动态',
    des: '脉流科技AccuICAS获美国FDA 510(k) 注册证，为全球颅内动脉狭窄功能学评估开启新时代',
    dynamicData: [
      { title: '开年首弹！脉流科技颅内“智能+诊疗”三大领域再添新证，实现大满贯！', des: '2023年2月28日，脉流科技颅内狭窄功能学评估产品AccuICAS获批美国FDA 510(k)。', year: '2023', time: '03-01', poster: 'https://www.arteryflow.com/file/news/20211125142733.png', url: 'https://mp.weixin.qq.com/s?__biz=MzUxNzU1NzU3NQ==&mid=2247505649&idx=1&sn=ff3d7dea98ca9d32c996eec16e4c0253&chksm=f994cad9cee343cf557f850e6afbf9456269476bc51b2b781cb4511363c0e37ad7a9467cd6f8&token=906348883&lang=zh_CN#rd' },
      { title: '引领时刻丨脉流科技基于医学图像的人工智能产品AccuLV正式获批上市！', des: '近日，由杭州脉流科技有限公司（以下简称“脉流科技”）自主研发的适用于心脏无创功能学评估产品—AccuLV®获得境内医疗器械注册证。该产品应用图像处理和深度学习等技术，辅助临床进行心脏功能学评估！该产品的成功研发体现了脉流科技的人工智能技术在心脏领域的领先地位和不断追求技术创新的决心，同时也为心脏疾病的诊断带来了新的曙光。', year: '2024', time: '06-27', poster: 'https://www.arteryflow.com/file/news/20211125141840.png', url: 'https://mp.weixin.qq.com/s/P7AsOROd55-tCLgZhosmgQ' }
    ]
  },
  partner: {
    title: '合作伙伴',
    des: '脉流科技与上百家医院的深度合作',
    type: ['颅内', '心内'],
    skull: {
      title: '颅内合作医院',
      des: 'Cooperative hospitals in neurointervention'
    },
    heart: {
      title: '心内合作医院',
      des: 'Cooperative hospitals in cardiology'
    }
  }
}
export default frontPage
